<h4 matDialogTitle>{{ 'general.politiqueProtectionDonnees' | translate }}</h4>

<mat-dialog-content style="max-height: 460px">
  <div [innerHTML]="texte | safeHtml"></div>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="btn " [mat-dialog-close]="false">{{ 'general.close' | translate }}</button>
</mat-dialog-actions>



